var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"app-sheet",class:_vm.noPadding ? '' : 'pa-4'},_vm.$listeners),[_vm._t("default"),(!_vm.HiddenActionArea)?_c('div',{staticClass:"app-sheet-divider"}):_vm._e(),(!_vm.HiddenActionArea)?_vm._t("action"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }